import BaseAccountController from '../../lib/controllers/BaseAccountController';

declare var LtFramework: lt.Static;

export default class ForgotPasswordController extends BaseAccountController {
	public static $inject: string[] = ['$scope', 'ForgotPasswordResource'];

	public emailErrorMessage: string;
	public generalError: string;
	public confirmationErrorMessage: string;
	public username: string;
	public email: string;
	public resetType: string;
	public submitted: boolean;

	private readonly ForgotPassword: MyAccountApi.IForgotPasswordResource;

	constructor($scope: ng.IScope, ForgotPasswordResource: MyAccountApi.IForgotPasswordResource) {
		super($scope);

		this.ForgotPassword = ForgotPasswordResource;
		this.resetType = LtFramework.global.lt.pageProperties.experienceType === 'member' ? 'mylt' : 'lthealth';
	}

	public cancel(): void {
		window.history.go(-1);
	}

	public submitRequest(form: ng.IFormController): void {
		this.generalError = '';

		if (form.$valid) {
			this.ForgotPassword.submit({username: this.username, email: this.email, resetType: this.resetType},
			() => {
				this.submitted = true;
			},
			(failure: MyAccountApi.IServiceFailureResponse ) => {
				if (failure && failure.data && failure.data.validationErrors) {
					this.generalError = failure.data.validationErrors[0].message;
				} else {
					this.generalError = 'Server error while attempting to reset password';
				}
			});
		}
	}

	public validateEmail(model: ng.INgModelController, email: string): void {
		this.emailErrorMessage = this.performValidation(email);
		model.$setValidity('email', this.emailErrorMessage === '');
	}

	private performValidation(email: string): string {
		const genericMessage = 'Sorry, that seems to be an invalid email format.';

		if (email == null) {
			return genericMessage;
		}

		const splitEmail = email.split('@');
		if (splitEmail.length !== 2) {
			return genericMessage;
		}

		const startWithError = /^(\.|www\.|https?)/.test(email);
		if (startWithError) {
			return genericMessage;
		}

		const localPart = splitEmail[0];
		const domainPart = splitEmail[1];
		const domainSplit = domainPart.split('.');

		if (localPart.length >= 65) {
			return 'Your new email address must be 140 characters or less.';
		}
		const tld = domainSplit[domainSplit.length - 1];

		if (domainSplit.length < 2) {
			return genericMessage;
		} else if (domainSplit.length === 2 && !domainSplit[0]) {
			return genericMessage;
		} else if (domainSplit.length >= 2) {
			let isError = false;
			domainSplit.forEach((dom: string) => {
				if (/^\-/.test(dom) || /\-$/.test(dom)) {
					isError = true;
				}
			});

			if (isError) {
				return genericMessage;
			}
		}

		if (tld.length < 2 || tld.length > 7) {
			return genericMessage;
		}

		if (email.length > 140) {
			return 'Your new email address must be 140 characters or less.';
		}

		if (/[^0-9a-zA-Z-.]/.test(splitEmail[1])) {
			return genericMessage;
		}

		if (/[^!#$%&'*/=-?^_{|}~.0-9a-zA-Z-\\]/.test(localPart)) {
			return genericMessage;
		}

		return '';
	}
}
